import React from 'react';
import {
  Col,
  Button,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
} from 'reactstrap';
import './lista-laminas.style.css';
import * as acessos from '../../../../acessos.const.util';

import IntlMessage from "../../../../helpers/intlMessage";

const ListaLaminasPage = (props) => (
  <Col
    className='mv-listalaminas-container espacamento-container-lateral'
    style={{
      height: props.alturaEditor(),
      overflowY: 'auto',
      overflowX: 'hidden',
    }}
  >
    {props.laminas !== undefined && props.laminas.length && (
      <div style={{ marginLeft: 15, marginTop: 15 }}>
        <ListGroup>
          {props.laminas !== undefined &&
            props.laminas.map((item, i) => (
              <ListGroupItem key={i} className='item-lista-laminas'>
                <ListGroupItemHeading>
                  <i className='fab fa-buffer'></i> {item.nrLamina}
                  {/* <div style={{  cursor: 'pointer', top: '16px', position: 'absolute', right: '15px'}} ><i className='fas fa-eye' onClick={() => window.open(process.env.REACT_APP_URL_VISUALIZADO_LAMINA)}></i></div> */}
                </ListGroupItemHeading>
              </ListGroupItem>
            ))}
        </ListGroup>
        {props.acessoPermitido(props.usuario, acessos.ListaLaminas) &&
          props.acessoPermitido(props.usuario, acessos.Adicionar) && (
            <Button
              color='primary'
              className='mv-inserir-button button-laminas'
              onClick={props.obterLaminas}
              style={{ marginBottom: 15 }}
            >
              <IntlMessage id = "dashboards.examDetail.insertReport"/>
            </Button>
          )}
      </div>
    )}
    {(props.laminas === undefined || !props.laminas.length) && (
      <div
        style={{
          height: `${props.altura - 48}px`,
          overflowY: 'hidden',
          overflowX: 'hidden',
        }}
      >
        <div
          style={{
            height: `100%`,
            padding: `${(props.altura - 48) / 2}px 20px ${
              (props.altura - 48) / 2
            }px 20px`,
          }}
        >
          <p className='mv-semItem'><IntlMessage id = "dashboards.examDetail.noBlades"/></p>
        </div>
      </div>
    )}
  </Col>
);

export default ListaLaminasPage;



// WEBPACK FOOTER //
// ./src/app/common/tabs/listaLaminas/lista-laminas.page.js